module.exports = __webpack_public_path__ + "img/premium-header.2eed0d69.svg";